import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <p>{` I like to learn something new every single day. Besides this, I am currently exploring JavaScript by writing blogs along the go to share what I have learned in an interesting and fun way.`}</p>
    <h3>{`Blogs`}</h3>
    <p>{`I never thought that blog-writing could be fun, but, it really was :)`}</p>
    <h4><a parentName="h4" {...{
        "href": "https://backtwobasics.vercel.app/call-apply-bind/"
      }}>{`What in earth do these .call(), .apply() and .bind() methods do ?`}</a></h4>
    <p>{`I really enjoyed documenting it... I've tried my best to make it interesting to read for beginner programmers.`}</p>
    <h4><a parentName="h4" {...{
        "href": "https://backtwobasics.vercel.app/event-capturing-bubbling/"
      }}>{`Capturing and Bubbling ? No! Bungee Jumping`}</a></h4>
    <p>{`Lame caption, I know, but the content is relatable. I've tried to relate concepts with real-life fundas.`}</p>
    <h4><a parentName="h4" {...{
        "href": "https://backtwobasics.vercel.app/parameters-arguments/"
      }}>{`Parameters ? Arguments ? Were they ever different ?`}</a></h4>
    <p>{`When I started learning to code, I struggled a lot in understanding the difference between the two. So, I thought, I shoud try explaining the difference my own way!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      